import { GET_FORMS ,UPDATE_FORM} from '../types'

const INITIAL_STATE = {
  allForms: [],
  updateForm:[],
}

const formReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_FORMS:
      return {
        ...state,
        allForms: payload,
      }
      case UPDATE_FORM:
        return {
          ...state,
          updateForm: payload,
        }

    default:
      return state
  }
}

export default formReducer
